import { useState } from "react";

const Checkout = () => {
  const [paymentMethod, setPaymentMethod] = useState("Credit/Debit Card");

  return (
    <div className="checkout-container">
      <a href="#" className="back-link">
        ← Back to Plans
      </a>
      <h2>Complete Your Purchase</h2>
      <p>Secure checkout for your Free Plan</p>

      <section className="payment-method">
        <h3>Payment Method</h3>
        {["Credit/Debit Card", "PayPal", "Bank Transfer"].map((method) => (
          <label key={method}>
            <input
              type="radio"
              name="payment-method"
              value={method}
              checked={paymentMethod === method}
              onChange={() => setPaymentMethod(method)}
            />
            {method}
          </label>
        ))}
      </section>

      <section className="billing-information">
        <h3>Billing Information</h3>
        <form>
          <input type="text" placeholder="First Name" />
          <input type="text" placeholder="Last Name" />
          <input type="email" placeholder="Email Address" />
          <input type="text" placeholder="Card Number" />
          <input type="text" placeholder="Expiry Date (MM/YY)" />
          <input type="text" placeholder="CVV" />
          <select>
            <option>Select Country</option>
            <option>India</option>
            <option>USA</option>
            <option>UK</option>
          </select>
          <button type="submit">Complete Purchase - $0/month</button>
        </form>
      </section>

      <section className="order-summary">
        <h3>Order Summary</h3>
        <p>
          <strong>Free Plan</strong>
        </p>
        <p>$0/month</p>
        <p>Up to 10 users</p>
        <hr />
        <p>
          <strong>Total: $0</strong>
        </p>
      </section>

      <footer>
        <p>🔒 SSL Encrypted</p>
        <p>🛡️ Secure Payment</p>
        <p>✅ 30-day Guarantee</p>
      </footer>
    </div>
  );
};

export default Checkout;
